import { render, staticRenderFns } from "./workroomForExpert.vue?vue&type=template&id=f2fe06d2&scoped=true&"
import script from "./workroomForExpert.vue?vue&type=script&lang=js&"
export * from "./workroomForExpert.vue?vue&type=script&lang=js&"
import style0 from "./workroomForExpert.vue?vue&type=style&index=0&id=f2fe06d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fe06d2",
  null
  
)

export default component.exports